import { render, staticRenderFns } from "./GuaranteeOnboardingIdentifiers.vue?vue&type=template&id=db8eb9a4&scoped=true&"
import script from "./GuaranteeOnboardingIdentifiers.vue?vue&type=script&lang=js&"
export * from "./GuaranteeOnboardingIdentifiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db8eb9a4",
  null
  
)

export default component.exports